import React from "react";
import {withTranslate} from "react-redux-multilingual";
import {stripHtml, trimString} from "./../../helpers/magic";
import {baseBlogImageUrl} from "../../config";

const BlogCard = ({post}) => {
    return (
        <a href={'/blog/post/' + post.post_name}>
            <div className="blog-entry shadow-4d align-self-stretch rounded-corners">

                <p  className="block top-rounded-corner pointer-event-none height-256"
                   style={{backgroundImage: `url(${baseBlogImageUrl + post.featured_image})`, backgroundSize: "cover"}}>
                </p>

                <div className="text p-4 d-block">
                    <h3 className="heading mt-3 trim">{post.post_title}</h3>
                    <p>{trimString(stripHtml(post.post_content), 55) + " .."}</p>

                </div>
            </div>
        </a>
    )
};

export default withTranslate(BlogCard)